import { useCallback, useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { CatalogItemLayers } from "@l2r-front/l2r-common"
import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation, useNetworksDispatchContext } from "@l2r-front/l2r-networks"

import { APP_CITY } from "../../../../common/constants/appCity"
import { MODULE_HORIZONTAL_SIGNING } from "../../../../common/constants/modules"
import { HorizontalSigningSource } from "../../containers/HorizontalSigningSource"

import { HorizontalSignValidator } from "../HorizontalSignValidator"

export function HorizontalSigningMapLayersRouter() {

    const matchRoad = useMatch(`:slugId/${APP_CITY}/${MODULE_HORIZONTAL_SIGNING}/:road/*`)
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null
    const isSegmentView = !!matchRoad

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedLinearLocations(feature)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked, setSelectedLinearLocations, navigateToLinearLocation, isSegmentView, road])

    const layers = useMemo(() => {
        return (
            <>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <CatalogItemLayers Source={HorizontalSigningSource} />
                {isSegmentView && <ImageCollectionLayer road={road} />}
                {isSegmentView && <ImageSelectedLayer />}
            </>
        )
    }, [isSegmentView, processNavigation, road])

    const layersRoutes = useMemo(() => ([
        { path: "/", element: layers },
        { path: "/:road", element: layers },
        { path: "/:road/:signId", element: <HorizontalSignValidator>{layers}</HorizontalSignValidator> },
    ]), [layers])

    return useRoutes(layersRoutes)
}